/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react'
import Cookies from 'universal-cookie';
import { useAccount } from 'wagmi'
import '../App.css'
import FunAbi from '../config/PumpFunAbi.json'
import TokenAbi from '../config/TokenAbi.json'
import StakingFactoryAbi from '../config/StakingFactoryAbi.json'
import StakingAbi from '../config/StakingAbi.json'
import '../styles/MainContainer.css'
import { readContract, writeContract } from '@wagmi/core'
import { waitForTransaction } from '@wagmi/core'
import Web3 from 'web3'
import { toast } from 'react-hot-toast'
import ClaimCard from '../components/ClaimCard.jsx'
import bnb from '../icons/bnb.svg'
import eth from '../icons/ETH.svg'
import pol from '../icons/polygon.svg'
import tao from '../icons/tao.png'
import uniswapBannerImg from '../icons/uniswap-banner.png'
import swapIcon from '../icons/swapIcon.png'
//import TopBar from '../components/TopBar'
import ClipLoader from 'react-spinners/ClipLoader'
import { useQueryParam, StringParam } from 'use-query-params'
import MyChart from '../components/Chart.jsx'
import Chart from '../components/tradingview/index.js'
import CopyIcon from '../icons/copy.svg'
import rot13 from '../utils/encode.ts'
import { web3Clients, imageUrl, apiUrl, scanApiLinks, apiKeys, chainNames1, scanLinks, chainNames, coinNames, projectName, supportedChainIds, zeroAddress } from '../utils/constants.ts'
import { ethPriceApiUrl } from '../utils/priceApi.ts';
import { getDefaultAddress } from '../utils/addressHelpers.ts'
import StreamContainer from "../components/Streaming/StreamContainer.tsx";
import Input from '../components/Input.tsx';
import { config } from '../config.jsx'
import { getStakingFactoryAddress, getExodiumTokenAddress } from '../utils/addressHelpers.ts';
import { BASE_URL } from '../utils/constants.ts';
import CustomRadioButton from '../components/CustomRadioButton'
import { SignMessage } from './SignMessage.jsx'
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon'
import { Link } from 'react-router-dom'
import '../styles/streaming.css';  // <-- import streaming styles

const App = () => {
  const ethIcon = {
    1: eth,
    56: bnb,
    11155111: eth,
    8453: eth,
    137: pol,
    10321: tao,
    97: bnb,
  }
  let [addressDatas] = useQueryParam('address', StringParam)
  let FunAddress
  let ref
  if (addressDatas.includes('/?ref=')) {
    FunAddress = addressDatas.split('/?ref=')[0]
    ref = addressDatas.split('/?ref=')[1]
  } else {
    FunAddress = addressDatas
  }
  const forceOwner = false; // queryParams.get('forceOwner'); // for debugging only
  let [chainId] = useQueryParam('chain', StringParam);
  const { address } = useAccount()
  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [maxLimit, setMaxLimit] = useState(1)
  const [tokenAddress, setTokenAddress] = useState('')
  const tokenLogo = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + FunAddress + '.png'
  const tokenBanner = imageUrl + 'banner/' + projectName + "-" + chainId + "-" + FunAddress + '.png'
  const [virtualLp, setVirtualLiquidiity] = useState(0)
  const [maxBuyAmount, setMaxBuyAmount] = useState(0)
  const [tokenAmount, setAmount] = useState()
  const [tokenOutAmount, setTokenOutAmount] = useState(0)
  let [accountBalance, setAccountBalance] = useState(0)
  let [, setInputBalance] = useState(0)
  let [tokenBalance, setTokenBalance] = useState(0)
  let [tokenAllowance, setTokenAllowance] = useState(0)
  const [virtualTokenLp, setVirtualTokenLp] = useState()
  const [tokenPrice, setTokenPrice] = useState(0)
  let [creating, setCreating] = useState(false)
  const [website, setWebsite] = useState()
  const [twitter, setTwitter] = useState()
  const [telegram, setTelegram] = useState()
  const [inputToken, setInputToken] = useState('ETH')
  const [transactions, setTransactions] = useState([])
  const [transactionDatas, setTransactionDatas] = useState([])
  const [tokenPriceDatas, setTokenPriceDatas] = useState()
  const [volume, setVolume] = useState(0)
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false)
  const [contractAddress, setContractAddress] = useState('')
  const [devAddress, setDevAddress] = useState('')
  const [, setRouterAddress] = useState('')
  const [description, setDescription] = useState('')

  const [refCounts, setRefCounts] = useState(0)
  const [totalRefAmounts, setTotalRefAmounts] = useState(0)
  const [refUserAmount, setRefUserAmout] = useState(0)

  const [lpCreated, setLpCreated] = useState(false)
  const [ethPrice, setEthPrice] = useState()
  // report
  const [showReportModal, setShowReportModal] = useState(false);

  // staking
  const [showStakingModal, setShowStakingModal] = useState(false);
  const [stakingPeriod, setStakingPeriod] = useState(90);
  const [stakingTokenAddress, setStakingTokenAddress] = useState(getExodiumTokenAddress(chainId));
  const [apy, setAPY] = useState(0);
  const [stakingFeeAmount, setStakingFeeAmount] = useState(0);
  const [stakingFeeTokenAmount, setStakingFeeTokenAmount] = useState(0);
  const [stakingAddress, setStakingAddress] = useState('');
  const [stakingTVL, setStakingTVL] = useState(0);
  const [stakingAPY, setStakingAPY] = useState(0);
  const [stakingUserBalance, setStakingUserBalance] = useState(0);
  const [stakedTokenAddress, setStakedTokenAddress] = useState('');
  const [lockingTime, setLockingTime] = useState(0);
  const [stakingTokenAmount, setStakingTokenAmount] = useState(0);
  const [stakedTokenAmount, setStakedTokenAmount] = useState(0);
  const [stakingRewardAmount, setStakingRewardAmount] = useState(0);
  const [reportReason, setReportReason] = useState('');
  const [isPaused, setIsPaused] = useState(false);
  const [chatHistory, setChatHistory] = useState([])
  const [chatContent,] = useState('')


  const handleReport = async () => {
    if (!address || !devAddress || !reportReason) {
      toast.error("Please provide a reason and ensure you're connected.");
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/api/submitReport`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          reporter: address,
          reportedUser: devAddress,
          reason: reportReason
        })
      });
      if (!response.ok) throw new Error("Failed to submit report");
      setShowReportModal(false);
      setReportReason('');
      toast.success("Report submitted successfully");
    } catch (error) {
      console.error("Error submitting report:", error);
      toast.error("Failed to submit report");
    }
  };

  let max =
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

  const cookies = new Cookies();
  if (ref) {
    if (Web3.utils.isAddress(rot13(ref))) {
      cookies.set('ref', ref)
    }
  }
  let refAddress
  if (cookies.get('ref')) {
    if (Web3.utils.isAddress(rot13(cookies.get('ref')))) {
      refAddress = rot13(cookies.get('ref'))
    }
  } else {
    refAddress = getDefaultAddress()
  }
  const REF_URL = BASE_URL + '/buy/?chain=' + chainId + '&address=' + FunAddress
  const referlink = address ? `${REF_URL}/?ref=${rot13(address)}` : `${REF_URL}/?ref=`

  const copyAddress = address => async e => {
    e.stopPropagation()
    e.preventDefault()
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = address
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      displayTooltip()
    }
  }

  function displayTooltip() {
    let timeoutId
    setIsTooltipDisplayed(true)
    timeoutId = setTimeout(() => {
      setIsTooltipDisplayed(false)
    }, 1000)
    return () => clearTimeout(timeoutId)
  }

  const onTokenSwap = async () => {
    try {
      setCreating(true)
      let swap
      let sendData;
      if (inputToken === 'ETH') {
        if (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100) {
          toast.error("You can't purchase more than max buy limit")
          setCreating(false)
          return;
        }
        swap = await writeContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'buyToken',
          value: web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'),
          args: [refAddress],
          chainId: Number(chainId)
        })
        await waitForTransaction(config, {
          hash: swap,
        })
        sendData = {
          chainId,
          buyer: address,
          type: 'bought',
          name: tokenSymbol,
          amount: tokenAmount,  // eth amount
          token: tokenAddress,
          contract: contractAddress,
          timestamp: (Date.now() / 1000).toFixed(0),
        }
      } else {
        if (tokenAllowance > tokenAmount) {
          if (tokenAmount > 1000000000 * maxBuyAmount / 100) {
            toast.error("You can't sell more than max sell limit")
            setCreating(false)

            return;
          }

          swap = await writeContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'sellToken',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), refAddress],
            chainId: Number(chainId)
          })

          await waitForTransaction(config, {
            hash: swap,
          })
          sendData = {
            chainId,
            buyer: address,
            type: 'Sold',
            name: tokenSymbol,
            amount: tokenAmount,
            token: tokenAddress,
            contract: contractAddress,
            timestamp: (Date.now() / 1000).toFixed(0)
          }
        } else {
          let approve
          let approveAddress;
          approveAddress = FunAddress
          approve = await writeContract(config, {
            address: tokenAddress,
            abi: TokenAbi,
            functionName: 'approve',
            args: [approveAddress, max],
            chainId: Number(chainId)
          })
          await waitForTransaction(config, {
            hash: approve,
          })
          toast.success("Successfully approved tokens")
          setCreating(false)

          return;
        }
        setInputToken(inputToken)
      }
      if (sendData) {
        const response = await fetch(apiUrl + '/addHistory', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'error',
          body: JSON.stringify(sendData)
        })
        if (response.status !== 200) {
          const { error } = await response.json()
          throw new Error(error)
        }
      }
      setTimeout(function () {
        setCreating(false)
      }, 3000)
      toast.success(`Successfully  ${inputToken !== 'ETH' ? Number(tokenAmount).toLocaleString() + " " + tokenSymbol : Number(tokenAmount) + " " + coinNames[chainId]} swapped`)
    } catch (err) {
      console.log('>>>>', err)
      if (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100) {
        const remainTokenAmount = 1000000000 * maxBuyAmount / 100 - Number(tokenBalance);
        toast.error("You can't purchase more than " + remainTokenAmount.toLocaleString() + ' ' + tokenSymbol)
      } else {
        toast.error('There is a problem with your Swap. Please try again later')
      }
      setCreating(false)
    }
  }

  useEffect(() => {
    const FetchData = async () => {
      if (!FunAddress || !chainId) {
        console.log("FetchData: FunAddress or chainId not set yet.");
        return;
      }
      try {
        const FunInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getFunBasicInfo',
          chainId: Number(chainId)
        })
        const StakingInfo = await readContract(config, {
          address: getStakingFactoryAddress(chainId),
          abi: StakingFactoryAbi,
          functionName: 'getStakingInfo',
          args: [FunAddress],
          chainId: Number(chainId)
        })

        // obtener precio real desde Scan API
        try {
          const price = await ethPriceApiUrl[chainId]()
          setEthPrice(price)
          setVolume(Number(FunInfo[0][9]) * price)
        } catch (err) {
          console.error('Error fetching price', err)
        }
        setTokenPriceDatas(FunInfo[7])
        setTokenName(FunInfo[1][0])
        setTokenSymbol(FunInfo[1][1])
        setTokenAddress(FunInfo[2][1])
        setMaxLimit(Number(FunInfo[0][2]))
        setVirtualLiquidiity(Number(FunInfo[0][5]) / 10 ** 18)
        setVirtualTokenLp(Number(FunInfo[0][4]) / 10 ** 18)
        setTokenPrice(Number(FunInfo[0][8]))
        setMaxBuyAmount(Number(FunInfo[0][2]))
        setWebsite(FunInfo[1][2])
        setTwitter(FunInfo[1][3])
        setTelegram(FunInfo[1][4])
        setContractAddress(FunInfo[2][0])
        setDevAddress(FunInfo[2][2])
        setRouterAddress(FunInfo[2][3])
        setRefCounts(Number(FunInfo[0][7]))
        setTotalRefAmounts(Number(FunInfo[0][6]) / 10 ** 18)
        setDescription(FunInfo[1][6])
        setLpCreated(FunInfo[4])

        setStakingFeeAmount(StakingInfo[0])
        setStakingFeeTokenAmount(StakingInfo[1])
        setStakingAddress(StakingInfo[4])
        if (address) {
          if (StakingInfo[4] !== zeroAddress) {
            const StakingInfos = await readContract(config, {
              address: StakingInfo[4],
              abi: StakingAbi,
              functionName: 'userInfo',
              args: [0, address],
              chainId: Number(chainId)
            })
            setStakedTokenAmount(StakingInfos[0]);
          }
          let accountBalance = await web3Clients[chainId].eth.getBalance(address)
          accountBalance = web3Clients[chainId].utils.fromWei(accountBalance, 'ether')
          setAccountBalance(accountBalance)
          if (inputToken === 'ETH') {
            setInputBalance(accountBalance)
          } else {
            setInputBalance(tokenBalance)
          }
          const refUserAmounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'refAmounts',
            args: [address],
            chainId: Number(chainId)
          })
          setRefUserAmout(Number(refUserAmounts) / (10 ** 18))
        }
      } catch (e) {
        console.error(e)
      }
    }
    if (creating === false) {
      FetchData()
    }
  }, [chainId, creating, FunAddress, address, web3Clients[chainId].eth, web3Clients[chainId].utils, inputToken, tokenBalance])


  useEffect(() => {
    const FetchData = async () => {
      try {
        const StakingInfo = await readContract(config, {
          address: stakingAddress,
          abi: StakingAbi,
          functionName: 'poolInfo',
          args: ["0"],
          chainId: Number(chainId)
        })
        // setStakingTVL(StakingInfo[0]);
        setStakedTokenAddress(StakingInfo[0]);
        setStakingAPY(StakingInfo[1]);
        setLockingTime(StakingInfo[2]);
        const stakedBalance = await readContract(config, {
          address: StakingInfo[0],
          abi: TokenAbi,
          functionName: 'balanceOf',
          args: [stakingAddress],
          chainId: Number(chainId)
        })
        setStakingTVL(Number(stakedBalance) / (10 ** 18).toFixed(0))

        if (address) {
          const StakingUserInfo = await readContract(config, {
            address: stakingAddress,
            abi: StakingAbi,
            functionName: 'userInfo',
            args: ["0", address],
            chainId: Number(chainId)
          })
          setStakingUserBalance(StakingUserInfo[0])
          if (StakingUserInfo[0] !== 0) {
            const rewardInfo = await readContract(config, {
              address: stakingAddress,
              abi: StakingAbi,
              functionName: 'pendingDToken',
              args: ["0", address],
              chainId: Number(chainId)
            })
            setStakingRewardAmount(rewardInfo)
          }
        }
      } catch (e) {
        console.error(e)
      }
    }
    if (showStakingModal === true && stakingAddress !== zeroAddress) {
      FetchData()
    }
  }, [showStakingModal, stakedTokenAmount])

  const onCreateStaking = async () => {
    try {
      setCreating(true)

      let allowance = await readContract(config, {
        address: stakingTokenAddress,
        abi: TokenAbi,
        functionName: 'allowance',
        args: [address, getStakingFactoryAddress(chainId)],
        chainId: Number(chainId)
      })
      if (allowance < stakingFeeTokenAmount) {
        let approve = await writeContract(config, {
          address: stakingTokenAddress,
          abi: TokenAbi,
          functionName: 'approve',
          args: [getStakingFactoryAddress(chainId), max],
          chainId: Number(chainId)
        })
        await waitForTransaction(config, {
          hash: approve,
        })
      }

      let staking = await writeContract(config, {
        address: getStakingFactoryAddress(chainId),
        abi: StakingFactoryAbi,
        functionName: 'createStaking',
        value: stakingTokenAddress !== getExodiumTokenAddress(chainId) ? web3Clients[chainId].utils.toWei(String(Number(stakingFeeAmount) / (10 ** 18)), 'ether') : '0',
        args: [tokenAddress, stakingTokenAddress, FunAddress, apy, stakingPeriod],
        chainId: Number(chainId)
      })
      await waitForTransaction(config, {
        hash: staking,
      })
      setTimeout(function () {
        setCreating(false)
      }, 3000)
      toast.success(`Successfully Staking Created`)
    } catch (err) {
      console.log('>>>>', err)
      toast.error("You don't have enough token on your wallet. Please purchase token first")
      setCreating(false)
    }
  }
  const onTokenStaking = async () => {
    try {
      setCreating(true)
      let allowance = await readContract(config, {
        address: stakedTokenAddress,
        abi: TokenAbi,
        functionName: 'allowance',
        args: [address, stakingAddress],
        chainId: Number(chainId)
      })
      if (Number(allowance) < Number(stakingTokenAmount) * (10 ** 18)) {
        let approve = await writeContract(config, {
          address: stakedTokenAddress,
          abi: TokenAbi,
          functionName: 'approve',
          args: [stakingAddress, max],
          chainId: Number(chainId)
        })
        await waitForTransaction(config, {
          hash: approve,
        })
      }
      let staking = await writeContract(config, {
        address: stakingAddress,
        abi: StakingAbi,
        functionName: 'deposit',
        args: [0, web3Clients[chainId].utils.toWei(String(stakingTokenAmount), 'ether')],
        chainId: Number(chainId)
      })
      await waitForTransaction(config, {
        hash: staking,
      })
      const StakingInfos = await readContract(config, {
        address: stakingAddress,
        abi: StakingAbi,
        functionName: 'userInfo',
        args: [0, address],
        chainId: Number(chainId)
      })
      setStakedTokenAmount(StakingInfos[0]);
      setTimeout(function () {
        setCreating(false)
      }, 3000)
      toast.success(`Successfully Staking Deposited`)
    } catch (err) {
      console.log('>>>>', err)
      toast.error("You don't have enough token on your wallet. Please purchase token first")
      setCreating(false)
    }
  }

  const onTokenWithdraw = async () => {
    try {
      setCreating(true)
      let withdraw = await writeContract(config, {
        address: stakingAddress,
        abi: StakingAbi,
        functionName: 'withdraw',
        args: [0, stakingUserBalance],
        chainId: Number(chainId)
      })
      await waitForTransaction(config, {
        hash: withdraw,
      })
      const StakingInfos = await readContract(config, {
        address: StakingInfo[4],
        abi: StakingAbi,
        functionName: 'userInfo',
        args: [0, address],
        chainId: Number(chainId)
      })
      setStakedTokenAmount(StakingInfos[0]);
      setTimeout(function () {
        setCreating(false)
      }, 3000)
      toast.success(`Successfully Staking Created`)
    } catch (err) {
      console.log('>>>>', err)
      toast.error('There is a problem with your Staking Creation. Please try again later')
      setCreating(false)
    }
  }


  const getApi = async () => {
    if (!FunAddress || !chainId) {
      console.log("getApi: FunAddress or chainId not set yet.");
      return;
    }
    try {
      const FunInfo = await readContract(config, {
        address: FunAddress,
        abi: FunAbi,
        functionName: 'getFunBasicInfo',
        chainId: Number(chainId)
      })
      setTokenPriceDatas(FunInfo[7])

      try {
        const price = await ethPriceApiUrl[chainId]()
        setEthPrice(price)
      } catch (e) {
        console.error(e)
      }

      try {
        await fetch(
          apiUrl + `/getOne/${FunAddress}`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json()
          if (!data.message) {
            let history
            let historyData = []
            for (let i = 0; i < data?.length; i++) {
              let sender = data[i].sender
              let content = data[i].content
              let currentDate = Date.now()
              let date = currentDate / 1000 - Number(data[i].timestamp)
              if (date > 86400) {
                date = (date / 86400).toFixed(0) + ' days ago'
              } else if (date > 3600) {
                date = (date / 3600).toFixed(0) + ' hours ago'
              } else if (date > 0) {
                date = (date / 60).toFixed(0) + ' mins ago'
              } else {
                date = ' just now'
              }
              let userAvatarUrl = imageUrl + `profile-${sender}.png`
              history = { Sender: sender, Content: content, Date: date, avatar: userAvatarUrl }
              historyData.push(history)
            }
            setChatHistory(historyData)
          }
        })
      } catch (e) {
        console.error(e)
      }

      // get transaction
      try {
        if (FunAddress) {
          await fetch(
            `${scanApiLinks[chainId]}?module=account&action=txlist&address=${FunAddress}&startblock=0&endblock=99999999&apiKey=${apiKeys[chainId]}`,
            // `https://api.routescan.io/v2/network/testnet/evm/${chainId}/address/${FunAddress}/transactions`,
            {
              method: 'GET'
            }
          ).then(async res => {
            let data = await res.json()
            if (data.status === "1") {
              setTransactions(data.result.filter(item => item.isError === "0"))
            }
          })
        }
      } catch (e) {
        console.error(e)
      }
    } catch (error) {
      console.error(`[BuyPage getApi] Error calling getFunBasicInfo for address: ${FunAddress} on chainId: ${chainId}`, error);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => getApi(), 10000)
    return () => clearInterval(interval)
  }, [])

  const setMaxAmount = async () => {
    if (accountBalance > 0) accountBalance = accountBalance - 0.00001
    if (inputToken === 'ETH') {
      setAmount(accountBalance)
    } else {
      setAmount(tokenBalance)
    }
  }


  const setStakingMaxAmount = async () => {
    setStakingTokenAmount(tokenBalance)
  }

  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let id
        if (inputToken === 'ETH') {
          id = '1'
        } else {
          id = '0'
        }
        let amounts
        if (Number(tokenAmount) > 0) {
          amounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'ethOrTokenAmount',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), id],
            chainId: Number(chainId)
          })

          setTokenOutAmount(Number((Number(amounts) / 10 ** 18).toFixed(3)))
        } else {
          setTokenOutAmount('')
        }
      } catch (e) {
        console.error(e)
      }
    }
    if (creating === false) {
      FetchAmount()
    }
  }, [inputToken, tokenAmount, creating])

  const chanageCurrency = async () => {
    if (inputToken === 'ETH') {
      setInputToken('Token')
      setInputBalance(tokenBalance)
      setAmount(tokenOutAmount)
    } else {
      setInputToken('ETH')
      setInputBalance(accountBalance)
      setAmount(tokenOutAmount)
    }
  }
  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let amounts
        amounts = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'balanceOf',
          args: [address],
          chainId: Number(chainId)
        })
        let allowance
        let approveAddress;
        approveAddress = FunAddress
        allowance = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'allowance',
          args: [address, approveAddress],
          chainId: Number(chainId)
        })
        setTokenAllowance(Number(allowance) / 10 ** 18)
        setTokenBalance((Math.floor(web3Clients[chainId].utils.fromWei(String(amounts), 'ether'))))
      } catch (e) {
        console.error(e)
      }
    }
    if (address && tokenAddress) {
      FetchAmount()
    }
  }, [tokenAddress, address, creating])

  useEffect(() => {

    const FetchTransaction = async () => {
      try {
        let transaction
        let transactionData = []
        for (let i = 0; i < transactions?.length; i++) {
          if (
            transactions[i].functionName.includes('buyToken') ||
            transactions[i].functionName.includes('sellToken')
          ) {
            let maker = transactions[i].from
            let type
            let amount
            if (transactions[i].functionName.includes('buyToken')) {
              type = 'Buy'
            } else {
              type = 'Sell'
            }
            amount = tokenPriceDatas[transactions?.length - (i)].amount;
            // amount = tokenPriceDatas[transactions?.length - (i)].amount;
            amount = '$' + (Number(web3Clients[chainId].utils.fromWei(String(amount), 'ether')) * ethPrice).toLocaleString()
            let date = new Date(Number(transactions[i].timeStamp) * 1000).getTime() / 1000
            let currentDate = Date.now()
            date = currentDate / 1000 - date
            if (date > 86400) {
              date = (date / 86400).toFixed(0) + ' days ago'
            } else if (date > 3600) {
              date = (date / 3600).toFixed(0) + ' hours ago'
            } else if (date > 0) {
              date = (date / 60).toFixed(0) + ' mins ago'
            } else {
              date = ' just now'
            }
            if (date < 0) {
              date = 'just now'
            }
            let tx = transactions[i].hash
            transaction = {
              Maker: maker,
              Type: type,
              Amount: amount,
              Date: date,
              Tx: tx
            }
            transactionData.push(transaction)
          }
        }
        setTransactionDatas(transactionData.reverse())
      } catch (e) {
        console.error(e)
      }
    }
    if (tokenAddress) {
      if (tokenAddress) {
        if (transactions?.length > 0) {
          FetchTransaction()
        }
        if (transactions?.length === 0) {
          getApi()
        }
      }
    }
  }, [tokenAddress, transactions])
  const [selectedOption, setSelectedOption] = useState('Chat')
  // Pagination State and Logic for Transactions Table
  const [currentTransactionPage, setCurrentTransactionPage] = useState(1)
  const [transactionTotalPages, setTransactionTotalPages] = useState(0)
  const transactionItemsPerPage = 5
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([])
  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = []

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages]
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ]
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1]
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages]
        }
      }
    }

    return pages
  }

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    )
  }

  useEffect(() => {
    const totalPages = Math.ceil(
      transactionDatas.length / transactionItemsPerPage
    )
    setTransactionTotalPages(totalPages)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    )
  }, [transactionDatas])
  const useScript = url => {
    useEffect(() => {
      const script = document.createElement('script');

      script.src = url;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      }
    }, [url]);
  };


  function isMobile() {
    try {
      document.createEvent('TouchEvent')
      return true
    } catch (e) {
      return false
    }
  }

  return (
    <div>
      {useScript('../../charting_library/charting_library.js')}
      <div className="GlobalContainer" style={showReportModal || showStakingModal ? { filter: 'blur(4px)' } : {}}>
        <div style={{ zIndex: 1 }}>
        
          <div className="pb-24 m-auto max-w-7xl pt-36 sm:py-10">
            <div className='flex flex-col lg:flex-row'>
              <section className="w-full">
                <div className='p-6'>
                  {lpCreated ?
                    <iframe
                      src={`https://dexscreener.com/${chainNames1[chainId]}/${tokenAddress}?embed=1&trades=0&info=0&theme=light`}
                      className="chart"
                      title="chart"
                    />
                    :
                    isMobile() ?
                      <MyChart data={tokenPriceDatas} ethPrice={ethPrice} />
                      :
                      <Chart data={tokenPriceDatas} ethPrice={ethPrice} interval="30" symbol={tokenSymbol} />
                  }
                </div>
                <div className='bg-[#050f1a00] rounded-[0px] overflow-hidden border border-[#13172200]'>
                  <div className="mt-2">
                    <div className="px-6 custom-radio-button-wrapper2">
                      <CustomRadioButton
                        value="Chat"
                        selectedValue={selectedOption}
                        handleSelect={setSelectedOption}
                      />
                      <CustomRadioButton
                        value="Trades"
                        selectedValue={selectedOption}
                        handleSelect={setSelectedOption}
                      />
                    </div>

                    {/* Trades section */}
                    {selectedOption === 'Trades' && (
                      <div className="w-full p-3 rounded-xl sm:p-6">
                        <p className='pb-2 font-bold text-center border-b-2 border-white'>Trades</p>
                        <div>
                          <div className="tradeBox py-2 pb-4 bg-[#131722]">
                            <p>Maker</p>
                            <p>Type</p>
                            <p>Amount</p>
                            <p>Date</p>
                            <p>Tx</p>
                          </div>

                          <div className='flex flex-col gap-2'>

                            {transactionDatas.length === 0 && (
                              <div className='flex bg-[#131722] py-3 -mt-2 border-t border-gray-600 justify-center text-white text-sm px-2'>No Data</div>
                            )}
                            {transactionDatas.length > 0 &&
                              transactionDatas
                                .slice(
                                  (currentTransactionPage - 1) * transactionItemsPerPage,
                                  currentTransactionPage * transactionItemsPerPage
                                )
                                .map(({ Maker, Type, Amount, Date, Tx }) => (
                                  <div
                                    key={Tx} // Use the unique transaction hash as the key
                                    className="flex bg-[#131722] py-3 border-t border-gray-600 justify-between px-2 sm:px-4 items-center -mt-2 text-center"
                                  >
                                    <div>
                                      <a
                                        className="holderContent"
                                        href={scanLinks[chainId] + 'address/' + Maker}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <p className="tokenLists text-[#0360b9]">
                                          {Maker.slice(0, 5) + '...' + Maker.slice(-3)}
                                        </p>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#0360b9"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="w-4 h-4 lucide-icon lucide lucide-external-link"
                                        >
                                          <path d="M15 3h6v6"></path>
                                          <path d="M10 14 21 3"></path>
                                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                        </svg>
                                        &nbsp;
                                      </a>
                                    </div>
                                    <div>
                                      <p
                                        className={
                                          Type === 'Buy'
                                            ? 'tokenLists tokenBuy text-green-500'
                                            : 'tokenLists tokenSell text-red-500'
                                        }
                                      >
                                        {Type}
                                      </p>
                                    </div>
                                    <div>
                                      <p className="tokenLists">{Amount}</p>
                                    </div>
                                    <div>
                                      <p className="tokenLists">{Date}</p>
                                    </div>
                                    <div>
                                      <a
                                        className="holderContent"
                                        href={scanLinks[chainId] + 'tx/' + Tx}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <p className="tokenLists text-[#0360b9]">
                                          {Tx.slice(0, 5) + '...' + Tx.slice(-3)}
                                        </p>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#0360b9"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="w-4 h-4 lucide-icon lucide lucide-external-link"
                                        >
                                          <path d="M15 3h6v6"></path>
                                          <path d="M10 14 21 3"></path>
                                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                        </svg>
                                        &nbsp;
                                      </a>
                                    </div>
                                  </div>
                                ))}
                            <div
                              className="flex justify-center my-4 border border-gray-600 rounded-[10px] w-fit mx-auto"
                              style={{ textAlign: 'right' }}
                            >
                              {/* Render the "First Page" button */}
                              <button
                                className="px-2 py-1 mx-1 text-white rounded-lg bg-primary"
                                onClick={() => handleTransactionPageChange(1)}
                              >
                                &lt;&lt;
                              </button>
                              {/* Render the "Previous Page" button */}
                              <button
                                className="px-2 py-1 mx-1 text-white rounded-lg bg-primary"
                                onClick={() =>
                                  handleTransactionPageChange(
                                    Math.max(currentTransactionPage - 1, 1)
                                  )
                                }
                              >
                                &lt;
                              </button>
                              {transactionPageNumbers.map((pageNumber, index) => {
                                if (typeof pageNumber === 'number') {
                                  return (
                                    <button
                                      key={pageNumber}
                                      className={`px-2 py-1 mx-1 ${currentTransactionPage === pageNumber
                                        ? 'bg-[#01010100] text-white'
                                        : 'bg-[#129a0a00] text-[#777]'
                                        } rounded-lg`}
                                      onClick={() =>
                                        handleTransactionPageChange(pageNumber)
                                      }
                                    >
                                      {pageNumber}
                                    </button>
                                  )
                                } else {
                                  return (
                                    <span
                                      key={pageNumber}
                                      className="px-2 py-1 mx-1 text-white bg-transparent rounded-lg"
                                    >
                                      ...
                                    </span>
                                  )
                                }
                              })}
                              {/* Render the "Next Page" button */}
                              <button
                                className="px-2 py-1 mx-1 text-white rounded-lg bg-primary"
                                onClick={() =>
                                  handleTransactionPageChange(
                                    Math.min(
                                      currentTransactionPage + 1,
                                      transactionTotalPages
                                    )
                                  )
                                }
                              >
                                &gt;
                              </button>
                              {/* Render the "Last Page" button */}
                              <button
                                className="px-2 py-1 mx-1 text-white rounded-lg bg-primary"
                                onClick={() =>
                                  handleTransactionPageChange(transactionTotalPages)
                                }
                              >
                                &gt;&gt;
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}


                    {/* Chat section */}
                    {selectedOption === 'Chat' && (
                      <section className="InputSection_Description p-6 rounded-[10px] backdrop-blur-[8px] border-2 border-[#ffffff66]">
                        {chatHistory.length > 0 ? (
                          <div>                            <div className='flex flex-col gap-1'>
                              {chatHistory.map(
                                ({ Sender, Content, Date, avatar }, index) => (
                                  <div 
                                    key={`chat-${Sender}-${Date}-${index}`}
                                    className="chatBox px-2 bg-[#6d79ad33] backdrop-blur-[8px] border-2 border-[#ffffff66]"
                                  >
                                    <div>
                                      <div className="relative chat-eth-logo-container">
                                        <Jazzicon diameter={40} seed={jsNumberForAddress(Sender)} />
                                        &nbsp; &nbsp;
                                        <div>
                                          <div className="top-trending">
                                            <Link
                                              className="chatContent"
                                              to={'/profile/?address=' + Sender}
                                              rel="noreferrer"
                                            >
                                              <p>
                                                {Sender.slice(0, 5) +
                                                  '...' +
                                                  Sender.slice(-3)}
                                              </p>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="w-4 h-4 lucide-icon lucide lucide-external-link"
                                              >
                                                <path d="M15 3h6v6"></path>
                                                <path d="M10 14 21 3"></path>
                                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                              </svg>
                                              &nbsp;
                                            </Link>
                                            &nbsp;
                                            <div>
                                              <p className="chatLists">{Date}</p>
                                            </div>
                                          </div>
                                          <div>
                                            <p className="chatLists">
                                              {Content}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="mt-4 ButtonBox">
                          <SignMessage
                            FunAddress={FunAddress}
                            sender={address}
                            content={chatContent}
                            timestamp={(Date.now() / 1000).toFixed(0)}
                          />
                        </div>
                      </section>
                    )}

                  </div>
                </div>
              </section>

              <section className="ClaimLeftColumn px-[16px]">
                <div className="relative stream-section">
                  <div className="stream-wrapper">
                    <StreamContainer
                      tokenAddress={tokenAddress}
                      connectedWallet={forceOwner ? devAddress : address}
                      ownerAddress={devAddress}
                      setShowReportModal={setShowReportModal}
                      showReportModal={showReportModal}
                      setIsPaused={setIsPaused}
                      isPaused={isPaused}
                    />
                  </div>
                  <div className='flex justify-between w-full'>
                    {address && devAddress === address && stakingAddress === zeroAddress && (
                      <button
                        onClick={() => setShowStakingModal(true)}
                        className="text-[16px] focus:outline-none h-[42px] flex justify-center items-center select-none font-bold text-center w-[50%] bg-gradient-to-r from-[#1c5290]  to-[#45c0be] hover:opacity-90 disabled:bg-[#4d6f8d] disabled:text-[#bbb] rounded-[10px] text-[#ffffff] mb-5"
                      >
                        Create Staking
                      </button>
                    )}
                    {address && stakingAddress !== zeroAddress && (
                      <button
                        onClick={() => setShowStakingModal(true)}
                        className="text-[16px] focus:outline-none h-[42px] flex justify-center items-center select-none font-bold text-center w-[50%] bg-gradient-to-r from-[#1c5290]  to-[#45c0be] hover:opacity-90 disabled:bg-[#4d6f8d] disabled:text-[#bbb] rounded-[10px] text-[#ffffff] mb-5"
                      >
                        Staking
                      </button>
                    )}
                  </div>
                </div>

                {lpCreated ?
                  <a
                    href={`https://app.uniswap.org/swap?chain=${chainNames[chainId]}&inputCurrency=ETH&outputCurrency=${tokenAddress}`}
                    target='_blank' rel="noreferrer"
                  >
                    <div className='overflow-hidden rounded-[25px] sm:mx-0 mx-[-15px]'>
                      <img src={uniswapBannerImg} className='' />
                    </div>
                  </a>
                  :
                  <div className="claim-card p-6 bg-[#6d79ad33] rounded-[10px] backdrop-blur-[8px] border-2 border-[#ffffff66]">
                    <header className="flex justify-between">
                      <span className="text-white -mt-4 mb-2 text-[20px] font-bold">{tokenSymbol}</span>
                    </header>
                    <div className='claim-token-content-box bg-[#010101] px-4 rounded-[10px] relative overflow-hidden'>
                      <p className='text-[14px]'>
                        <button onClick={copyAddress(tokenAddress)} className="CopyButton">
                          <div className="launchpad-cap-type">
                            {isTooltipDisplayed ? (
                              <span className="tooltiptext">Copied!</span>
                            ) : (
                              <div className='flex flex-row'>
                                {tokenAddress}
                                <img
                                  src={CopyIcon}
                                  alt=""
                                  width="32px"
                                  height="32px"
                                  className='absolute right-0 top-[4px] bg-gradient-to-r from-[#1c5290] to-[#45c0be] p-2'
                                />
                              </div>
                            )}
                          </div>
                        </button>
                      </p>
                    </div>
                    <section className="flex flex-col gap-6 mt-4">
                      <div className="swap-cards-container ">
                        <div className="relative flex flex-col gap-1">
                          <div className="w-full rounded-[10px] bg-[#010101] px-4 py-6 flex justify-between">
                            <div className="flex gap-[16px]">
                              <img alt="token icon" fetchpriority="high" width="40" height="40"
                                decoding="async" data-nimg="1" className="flex-shrink-0 w-10 h-10 rounded-full"
                                src={inputToken === 'ETH' ? ethIcon[chainId] : tokenLogo} />
                              <div className="flex flex-col">
                                <span className="text-[#919191] text-[12px] font-semibold">From</span>
                                <span className="text-white text-[20px] font-bold whitespace-nowrap overflow-hidden text-ellipsis">{inputToken === 'ETH' ? coinNames[chainId] : tokenSymbol.length > 8 ? `${tokenSymbol.slice(0, 8)}...` : tokenSymbol}</span>
                              </div>
                            </div>
                            <div className="relative flex flex-col items-end">
                              <input
                                type="number"
                                placeholder="0"
                                className="placeholder:text-[#919191] bg-transparent max-w-[180px] focus:outline-none text-white text-[20px] font-bold text-right"
                                value={tokenAmount}
                                onChange={e => setAmount(e.target.value)}
                                min="0"
                                required
                              />
                              <div className="flex items-center gap-2">
                                <span className="text-[#919191] text-[12px] font-semibold flex gap-1">
                                  Balance: &nbsp;{Number(inputToken === 'ETH' ? accountBalance : tokenBalance).toLocaleString()}{' '}
                                  <div className='cursor-pointer text-[#0360b9]' onClick={setMaxAmount}>Max</div>
                                </span>
                                {/* // <button className='border border-[#0360b9] text-[#fff] rounded-md px-1' onClick={setMaxAmount}>Max</button> */}
                              </div>
                            </div>
                          </div>
                          <div className="w-full rounded-[10px] bg-[#010101] px-4 py-6 flex justify-between">
                            <div className="flex gap-[16px]">
                              <img alt="token icon" fetchpriority="high" className="flex-shrink-0 w-10 h-10 rounded-full" width="40" height="40" src={inputToken !== 'ETH' ? ethIcon[chainId] : tokenLogo} />
                              <div className="flex flex-col">
                                <span className="text-[#919191] text-[12px] font-semibold">To</span>
                                <span className="text-white text-[20px] font-bold whitespace-nowrap overflow-hidden text-ellipsis">{inputToken !== 'ETH' ? coinNames[chainId] : tokenSymbol}</span>
                              </div>
                            </div>
                            <div className="relative flex flex-col items-end flex-grow">
                              <input
                                placeholder="0"
                                label=""
                                type="number"
                                value={tokenOutAmount}
                                className="text-white text-right text-[20px] font-bold"
                                disabled
                              />
                              <div className="flex items-center gap-2">
                                <span className="text-[#919191] text-[12px] font-semibold">
                                  Balance: &nbsp;{Number(inputToken !== 'ETH' ? accountBalance : tokenBalance).toLocaleString()}{' '}
                                  {/* {inputToken !== 'ETH' ? coinNames[chainId] : tokenSymbol} */}
                                </span>
                              </div>
                            </div>
                          </div>
                          <button className="absolute transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 " onClick={chanageCurrency}>
                            <img alt="swap" loading="lazy" width="40" height="40" decoding="async" data-nimg="1"
                              src={swapIcon} />
                          </button>
                        </div>
                      </div>
                      {address === undefined ? (<w3m-button />) :
                        supportedChainIds.includes(Number(chainId)) ? <button onClick={onTokenSwap} className="text-[16px] focus:outline-none h-[48px] flex justify-center items-center select-none font-bold text-center w-full bg-gradient-to-r from-[#1c5290]  to-[#45c0be] hover:opacity-90 disabled:bg-[#4d6f8d] disabled:text-[#bbb] rounded-[10px] text-[#ffffff]" disabled={address !== undefined && (Number(tokenAmount) > 0 && (inputToken === 'ETH' ? accountBalance >= Number(tokenAmount) : tokenBalance >= Number(tokenAmount))) ? false : true}>
                          {
                            inputToken !== 'ETH' && tokenAllowance === 0
                              ? creating === false
                                ? 'Approve token First'
                                : <ClipLoader
                                  color={'#fff'}
                                  loading={creating}
                                  size={30}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              : creating === false
                                ? 'Swap Tokens'
                                : <ClipLoader
                                  color={'#fff'}
                                  loading={creating}
                                  size={30}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />}
                        </button>
                          :
                          <w3m-button />}
                    </section>
                    {/* 
                    <div
                      className="token-info-item"
                      style={{ marginTop: '10px' }}
                    >
                      <span className="token-info-label">Current Price</span>
                      <span className="token-info-value">$
                        {((tokenPrice) / 10 ** 12).toLocaleString()}</span>
                    </div> */}
                  </div>
                }

                <ClaimCard
                  tokenName={tokenName}
                  Logo={<img src={tokenLogo} className="claim-eth-logo" />}
                  tokenAddress={tokenAddress}
                  contractAddress={contractAddress}
                  dexAddress="https://app.uniswap.org/swap"
                  devAddress={devAddress}
                  dexName="Uniswap"
                  tokenSymbol={tokenSymbol}
                  maxLimit={maxLimit}
                  tokenDecimals={18}
                  tokenTotalSupply={1000000000}
                  maxBuyAmount={maxBuyAmount}
                  tokenSupplyUSD={2 * virtualLp * ethPrice}
                  tokenSupplyLiquidity={virtualTokenLp}
                  tokenPrice={tokenPrice}
                  tokenUnsoldTokens={'Burned 🔥'}
                  tokenCover={tokenBanner}
                  website={website}
                  telegram={telegram}
                  twitter={twitter}
                  volume={volume}
                  description={description}
                  ethPrice={ethPrice}
                  lpCreated={lpCreated}
                />
                <br />
                <div className="claim-card p-6 bg-[#6d79ad33] rounded-[10px] backdrop-blur-[8px] border-2 border-[#ffffff66]">
                  <div className="token-info-item">
                    <span className="mx-auto token-info-label">
                      <h3 className='text-white font-bold text-[24px]' style={{ marginTop: '0px' }}>
                        Earn <span className='text-[#7db4e5]'>0.5%</span> of each trade
                      </h3>
                    </span>
                  </div>
                  <div className="mt-2 token-info-item">
                    <span className="font-light token-info-label">
                      Share referral link with your friends and earn 0.5% of every
                      trade they make.
                    </span>
                  </div>
                  <br />
                  <div className='bg-[#010101] flex w-full items-center gap-2 rounded-[8px] py-[14px] pr-[8px] pl-[16px]'>
                    <span className='text-[16px] text-white font-semibold w-[280px] truncate'>{isTooltipDisplayed ? "Copied" : referlink}</span>
                    <button className='flex justify-center items-center w-12 h-12 rounded-[8px] bg-[#233f53] hover:bg-[#3b5e76]' onClick={copyAddress(referlink)}>
                      <img src={CopyIcon} />
                    </button>
                  </div>
                  {refUserAmount > 0 ?
                    <div>
                      <div className="RefBox">
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          Total Refferal Amounts:
                        </p>
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          {totalRefAmounts} BNB
                        </p>
                      </div>
                      <hr />
                      <div className="RefBox">
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          Total Ref Counts:
                        </p>
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          {refCounts}
                        </p>
                      </div>
                      <hr />
                      <div className="RefBox">
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          Your referral amounts:
                        </p>
                        <p
                          style={{
                            textAlign: 'center',
                            margin: '0px'
                          }}
                          className="tokenLists"
                        >
                          {refUserAmount} BNB
                        </p>
                      </div>
                      <hr />
                    </div> :
                    <></>}
                </div>
                <br />
              </section>

            </div>
          </div>
        </div>
      </div>
      {showStakingModal && (
        <section className="modal" style={isMobile() ?
          { position: 'fixed', top: '20%', left: '10%', right: '10%', background: '#050f1ae6', padding: '20px', borderRadius: '10px', zIndex: 1000 }
          :
          { position: 'fixed', top: '20%', left: '30%', right: '30%', background: '#050f1ae6', padding: '20px', borderRadius: '10px', zIndex: 1000 }}>
          {stakingAddress === zeroAddress
            ?
            <>
              <h2 className='text-[#919191] mb-2'>Create Staking</h2>
              <div className="order-2 bg-[#050f1ae6] px-[16px] py-[14px] rounded-[10px]">
                <section className="flex flex-col w-full mb-5">
                  <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                    APY<span style={{ color: 'red' }}>*</span>
                  </p>
                  <div className="order-2 px-[16px] py-[14px] rounded-[10px] bg-[#071d35]">
                    <Input
                      placeholder="Enter the Simbol"
                      label=""
                      type="text"
                      changeValue={setAPY}
                      value={apy}
                    />
                  </div>
                </section>
                <section className="flex flex-col w-full mb-5">
                  <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                    Staking Period
                  </p>
                  <div className="order-2 bg-[#071d35] px-[16px] py-[14px] rounded-[10px]">
                    <section className="inputPanel">
                      <section className="inputPanelHeader">
                        <div className="fairlaunch-allocation-buttons-container">
                          <button
                            className="fairlaunch-allocation-button"
                            onClick={() => setStakingPeriod(90)}
                            style={
                              stakingPeriod === 90
                                ? {}
                                : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                            }
                          >
                            3 Months
                          </button>
                          <button
                            className="fairlaunch-allocation-button"
                            onClick={() => setStakingPeriod(150)}
                            style={
                              stakingPeriod === 150
                                ? {}
                                : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                            }
                          >
                            5 Months
                          </button>
                          <button
                            className="fairlaunch-allocation-button"
                            onClick={() => setStakingPeriod(240)}
                            style={
                              stakingPeriod === 240
                                ? {}
                                : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                            }
                          >
                            8 Months
                          </button>
                        </div>
                      </section>
                    </section>
                  </div>
                </section>

                <section className="flex flex-col w-full mb-5">
                  <p className="text-[12px] text-[#7db4e5] mb-2 order-1">
                    Staking Token
                  </p>
                  <div className="order-2 bg-[#071d35] px-[16px] py-[14px] rounded-[10px]">
                    <section className="inputPanel">
                      <section className="inputPanelHeader">
                        <div className="fairlaunch-allocation-buttons-container">
                          <button
                            className="fairlaunch-allocation-button"
                            onClick={() => setStakingTokenAddress(getExodiumTokenAddress(chainId))}
                            style={
                              stakingTokenAddress === getExodiumTokenAddress(chainId)
                                ? {}
                                : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                            }
                          >
                            Exodium Token
                          </button>
                          <button
                            className="fairlaunch-allocation-button"
                            onClick={() => setStakingTokenAddress(tokenAddress)}
                            style={
                              stakingTokenAddress === tokenAddress
                                ? {}
                                : { background: 'transparent', color: '#d9d2da', border: 'solid #d9d2da 1px' }
                            }
                          >
                            {tokenName} Token
                          </button>
                        </div>
                      </section>
                    </section>
                    {stakingTokenAddress !== getExodiumTokenAddress(chainId) ? <p className="text-[12px] text-[#7db4e5] mt-4 order-1">You need to send {Number(stakingFeeAmount) / (10 ** 18)} {coinNames[chainId]} to create staking<span style={{ color: 'red' }}>*</span></p> : <></>}
                  </div>
                </section>
                <p className="text-[12px] text-[#7db4e5] mt-2 mb-4 order-1">You need to send {Number(stakingFeeTokenAmount) / (10 ** 18)} {stakingTokenAddress !== getExodiumTokenAddress(chainId) ? tokenName : 'Exodium'} token to create staking<span style={{ color: 'red' }}>*</span></p>
                {creating ?
                  <ClipLoader
                    color={'#fff'}
                    loading={creating}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                  :
                  <>
                    <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50" onClick={onCreateStaking} style={{ marginRight: '10px' }}>Create</button>
                    <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50" onClick={() => setShowStakingModal(false)}>Cancel</button>
                  </>
                }

              </div>
            </>
            :
            <>
              <h2 className='text-[#919191] mb-2'>Staking Info</h2>
              <div className="order-2 bg-[#050f1a] px-[16px] py-[14px] rounded-[10px]">

                <div className="swap-cards-container ">
                  <div className="relative flex flex-row gap-1 md:flex-col">
                    <div className="w-full rounded-[10px] bg-[#010101] px-4 py-4 flex justify-between">
                      <div className="flex gap-[16px]">
                        <img alt="token icon" fetchpriority="high" width="40" height="40"
                          decoding="async" data-nimg="1" className="flex-shrink-0 w-10 h-10 rounded-full"
                          src={tokenLogo} />
                        <div className="flex flex-col">
                          <span className="text-white text-[20px] font-bold whitespace-nowrap overflow-hidden text-ellipsis">{tokenSymbol.length > 8 ? `${tokenSymbol.slice(0, 8)}...` : tokenSymbol}</span>
                        </div>
                      </div>
                      <div className="relative flex flex-col items-end">
                        <input
                          type="number"
                          placeholder="0"
                          className="placeholder:text-[#919191] bg-transparent max-w-[180px] focus:outline-none text-white text-[20px] font-bold text-right"
                          value={stakingTokenAmount}
                          onChange={e => setStakingTokenAmount(e.target.value)}
                          min="0"
                          required
                        />
                        <div className="flex items-center gap-2">
                          <span className="text-[#919191] text-[12px] font-semibold flex gap-1">
                            Balance: &nbsp;{Number(tokenBalance).toLocaleString()}{' '}
                            <div className='cursor-pointer text-[#0360b9]' onClick={setStakingMaxAmount}>Max</div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section className="flex flex-col items-start w-full mt-5 mb-5 md:flex-row md:justify-evenly">
                  <div className='flex flex-col'>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      APY : &nbsp; {stakingAPY} %
                    </p>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      TVL : &nbsp; {stakingTVL.toFixed(2)} &nbsp; {tokenSymbol}
                    </p>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      Locking Time : &nbsp;  {(Number(lockingTime) / 30).toFixed(0)} Months
                    </p>
                  </div>
                  <div className='flex flex-col'>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      Reward Token : &nbsp;  {stakedTokenAddress === tokenAddress ? tokenName : "Exodium Token"}
                    </p>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      Your Deposited Balance : &nbsp;  {(Number(stakingUserBalance) / (10 ** 18)).toFixed(0)} &nbsp; {tokenSymbol}
                    </p>
                    <p className="text-[16px] text-[#7db4e5] mb-2 order-1">
                      Your Reward Balance : &nbsp;  {(Number(stakingRewardAmount) / (10 ** 18)).toFixed(0)} &nbsp; {tokenSymbol}
                    </p>
                  </div>


                </section>
                <div className='flex m-auto w-fit'>
                  {!creating ?
                    <div className={isMobile() && 'flex flex-col m-auto'}>
                      <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50 mt-2" onClick={onTokenStaking} style={{ marginRight: '10px' }}>Stake</button>
                      <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50 mt-2" onClick={onTokenWithdraw} style={{ marginRight: '10px' }} disabled={Number(stakedTokenAmount) === 0 ? true : false}>Withdraw</button>
                      <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50 mt-2" onClick={() => setShowStakingModal(false)}>Cancel</button>
                    </div>
                    :
                    <ClipLoader
                      color={'#fff'}
                      loading={creating}
                      size={30}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  }
                </div>
              </div>
            </>
          }
        </section>
      )}

      {showReportModal && (
        <section className="modal" style={isMobile() ?
          { position: 'fixed', top: '20%', left: '10%', right: '10%', background: '#050f1ae6', padding: '20px', borderRadius: '10px', zIndex: 1000 }
          :
          { position: 'fixed', top: '20%', left: '20%', right: '20%', background: '#050f1ae6', padding: '20px', borderRadius: '10px', zIndex: 1000 }}>
          <h2 className='text-[#919191] mb-2'>Report Stream</h2>
          <div className="order-2 bg-[#050f1ae6] px-[16px] py-[14px] rounded-[10px]">
            <textarea
              value={reportReason}
              onChange={(e) => setReportReason(e.target.value)}
              placeholder="Enter reason for report"
              style={{ width: '100%', background: '#172738', height: '100px', marginBottom: '10px', color: 'white', borderRadius: '5px', padding: '10px' }}
            />
            <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50" onClick={handleReport} style={{ marginRight: '10px' }}>Submit</button>
            <button className="px-6 py-2 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded-lg disabled:opacity-50" onClick={() => setShowReportModal(false)}>Cancel</button>
          </div>
        </section>
      )}
    </div>
  )
}

export default App